import styled from "styled-components";
import React from "react";
import { UserPassword } from "../../assets/User/UserPassword";
import PasswordChangeForm from "../../components/forms/PasswordChangeForm";

const StyleCss = styled.div`
  
`;

function ChangePassword(props) {
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
          <div className="icon"><UserPassword/></div>
          <div className="text">تغییر رمز عبور</div>
          </div>
      </div>
      <div className="content">
        <PasswordChangeForm {...props}/>
      </div>
    </StyleCss>
);
}
export default ChangePassword;